/* @flow */
import * as React from "react";
import styled, { css } from "styled-components";
import { rgba } from "polished";

import Gettext from "../../common/Gettext";
import { Link as BasicLink } from "../../common/Link";

import BasicModal from "../Modal";

const Modal = styled(BasicModal)`
  max-width: 68em;
  padding: 4em 4em 3.5em;
  color: ${({ theme }) => rgba(theme.foreground, 0.75)};

  @media (max-width: 959px) {
    max-width: 60em;
    padding: 3.143em 5em;
    border-radius: 0px;
  }

  @media (max-width: 959px) and (min-width: 480px) {
    padding: 2em 3.5em;
  }
`;

const Heading = styled.h3`
  width: 100%;
  padding: 0 0.5em 0.5em;
  font-weight: 300;
  font-size: 3em;
  text-transform: uppercase;
  color: ${props => props.theme.lower};

  @media (max-width: 959px) {
    padding: 0 1em 0.75em;
    font-size: 3.429em;
    line-height: 1.2;
  }
  @media (max-width: 959px) and (min-width: 480px) {
    padding-bottom: 0.25em;
  }
`;

const Text = styled.div`
  font-weight: 400;
  font-size: 1.8em;
  line-height: 1.333;
  color: inherit;

  @media (max-width: 959px) {
    font-size: 1.714em;
    line-height: 1.5;
  }
`;

const VerifiedContainer = styled.ul`
  width: fit-content;
  max-width: 77.5%;
  margin: 0 auto;
  padding: 3em 0 3.5em;
  text-align: left;

  @media (max-width: 959px) {
    padding-top: 1em;
    padding-bottom: 1em;
  }
`;

const Verified = styled.li`
  position: relative;
  margin: 0;
  padding: 0 0 0 1.5em;
  font-weight: 700;
  font-size: 1.8em;
  line-height: 1.667;
  color: ${props => props.theme.lower};

  :before {
    content: "*";
    position: absolute;
    top: 0px;
    left: 0px;
    font-weight: inherit;
    font-size: 34px;
    line-height: 1.2;
  }

  ${props =>
    props.isVerified &&
    css`
      color: ${props => props.theme.upper};

      :before {
        content: "";
        left: 2px;
        width: 0.35em;
        height: 0.6em;
        border-right: 3px solid ${props => props.theme.upper};
        border-bottom: 3px solid ${props => props.theme.upper};
        transform: rotate(45deg);
      }
    `} @media (max-width: 959px) {
    padding-top: 0.5em;
    padding-bottom: 0.5em;
    padding-left: 1.75em;
    font-size: 2em;
    line-height: 1.2;

    :before {
      top: 2px;
      font-size: 28px;
    }
  }

  @media (max-width: 959px) and (min-width: 480px) {
    padding-top: 0.25em;
    padding-bottom: 0.25em;

    :before {
      top: -1px;
    }
  }
`;

const Link = styled(BasicLink)`
  display: table;
  width: fit-content;
  max-width: 20em;
  margin: 0 auto;
  padding: 1.045em 2.75em;
  font-weight: 700;
  font-size: 2.2em;
  line-height: 1;
  text-align: center;
  text-decoration: none;
  color: #fff;
  border: none;
  border-radius: 0.364em;
  background-color: #61ad12;
  background: linear-gradient(to bottom, #68c604 0%, #61ad12 100%);
  cursor: pointer;

  :hover {
    background-color: #68c604;
    background: linear-gradient(to bottom, #61ad12 0%, #68c604 100%);
  }

  @media (max-width: 959px) {
    padding-left: 1.75em;
    padding-right: 1.75em;
    font-size: 2.286em; /* 16px */
    border-radius: 0.25em;
  }
`;

type Props = {
  validation: Object,
  onDismiss: () => void
};

const FIELDS = [
  {
    title: <Gettext>Confirm phone</Gettext>,
    key: "phone"
  },
  {
    title: <Gettext>Confirm Email</Gettext>,
    key: "email"
  },
  {
    title: <Gettext>Fill in all profile fields</Gettext>,
    key: "profile"
  },
  {
    title: <Gettext>Attach a copy of your ID or passport</Gettext>,
    key: "passport"
  }
];

function VerificationRequired(props: Props) {
  return (
    <Modal onDismiss={props.onDismiss}>
      <Heading>
        <Gettext>Verification is necessary!</Gettext>
      </Heading>

      <Text>
        <Gettext>
          You have to verify your account to comply with financial regulation
          rules. Verify your account on the Profile page to keep the information
          about your deposits and withdrawals safe and secure.
        </Gettext>
      </Text>

      <VerifiedContainer>
        {FIELDS.map(field => (
          <Verified
            isVerified={props.validation[field.key] === 1}
            key={field.key}
          >
            {field.title}
          </Verified>
        ))}
        {props.validation.idconfirmation !== undefined &&
          <Verified
            isVerified={props.validation.idconfirmation === 1}
            key="idconfirmation"
          >
            <Gettext>Attach your photo with your ID</Gettext>
          </Verified>

        }
      </VerifiedContainer>

      <Link to="/verification">
        <Gettext>Verify</Gettext>
      </Link>
    </Modal>
  );
}

export default VerificationRequired;



// WEBPACK FOOTER //
// ./src/components/TradeModals/VerificationRequired/VerificationRequired.js